import { Capacitor } from '@capacitor/core';
import { Camera } from '@capacitor/camera';
import { ArController } from './ar';

const container = document.getElementById('ar-container');
const debug = document.getElementById('debug-overlay');
const scanPrompt = document.getElementById('scan-prompt');

function status(msg: string): void {
  console.log(`[ar] ${msg}`);
  if (debug) debug.textContent = msg;
  if (scanPrompt) {
    if (msg.includes('ορατή') || msg.includes('επαύξηση')) {
      scanPrompt.classList.add('hidden');
    } else if (msg.includes('σαρώστε') || msg.includes('αναζήτηση')) {
      scanPrompt.classList.remove('hidden');
    }
  }
}

async function requestCameraPermission(): Promise<boolean> {
  if (Capacitor.getPlatform() !== 'android') return true;
  try {
    const current = await Camera.checkPermissions();
    if (current.camera === 'granted') return true;
    const requested = await Camera.requestPermissions({ permissions: ['camera'] });
    return requested.camera === 'granted';
  } catch (err) {
    console.error('[ar] camera permission error', err);
    return false;
  }
}

async function boot(): Promise<void> {
  if (!container) {
    status('σφάλμα: λείπει #ar-container');
    return;
  }

  status(`platform: ${Capacitor.getPlatform()}`);

  const granted = await requestCameraPermission();
  if (!granted) {
    status('χωρίς άδεια κάμερας');
    return;
  }

  const ar = new ArController();
  try {
    await ar.init({
      container,
      targetSrc: '/targets/cards.mind',
      onStatus: status,
    });
  } catch (err) {
    const e = err as Error;
    console.error(e);
    status(`αποτυχία εκκίνησης: ${e.message}`);
  }
}

boot().catch((err) => {
  console.error(err);
  status(`fatal: ${err?.message ?? String(err)}`);
});
